import { isMeetingId } from '@/lib/meeting-id.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export function usePageTitle() {
  const location = useLocation();
  const { t } = useTranslation();

  return useMemo(() => {
    const path = location.pathname.split('/')[1];
    if (!path) return '';

    if (path === 'profile' || path === 'admin') {
      const section = location.pathname.split('/')[2];
      return section ? t(`navigation.${section}`) : t(`navigation.${path}`);
    }

    if (isMeetingId(path)) return '';

    const titleMap: Record<string, string> = {
      history: t('navigation.history'),
      pricing: t('navigation.pricing'),
      auth: t('auth.login'),
      ask: t('navigation.ask'),
    };

    return titleMap[path] || '';
  }, [location.pathname, t]);
}
